import { Component, OnInit } from '@angular/core';
import { Company } from '../../../models/company';
import { Location } from '../../../models/location';
import { Client_Vehicle } from '../../../models/client_Vehicle';

import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { CustomerTypeService } from '../../../services/customer-type.service';
import { LocationService } from '../../../services/location.service';
import { VehicleService } from '../../../services/vehicle.service';
import { Router } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { Customer_Type } from '../../../models/customer_Type';
import { ClientAuditReportService } from '../../../services/client-audit-report.service';
import { CheckUserType } from '../../../models/checkUserType';
import { ColumnService } from '../../../services/ColumnService';

@Component({
  selector: 'app-client-audit-report',
  templateUrl: './client-audit-report.component.html',
  styleUrls: ['./client-audit-report.component.css']
})
export class ClientAuditReportComponent implements OnInit {
  role = new CheckUserType();
  client;

  companyService: CompanyService;
  locationService: LocationService;
  vehicleService: VehicleService;

  customerTypes: Customer_Type[];

  companies: Company[];
  companyList: Company[];

  locations: Location[];
  locationList: Location[];


  vehicles: Client_Vehicle[];
  vehicleList: Client_Vehicle[];

  filter: any = {
    customer_Type_Id: 0,
    company_Id: 0,
    location_Id: 0,
    vehicle_Id: 0,
    start_Date: moment().toDate(),
    end_Date: moment().toDate(),
    quick_Search: ""
  };

  selectedOptions: string[] = [
    'Date',
    'Customer',
    'Account #',
    'Registration',
    'Location Address',
    'Postcode',
    'Customer Type',
    'User',
    '# of Cyls'
  ];

  availableOptions: string[] = [
    'Date',
    'Customer',
    'Account #',
    'Registration',
    'Location Address',
    'Postcode',
    'Customer Type',
    'User',
    '# of Cyls'
  ];

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;

  showPopup: boolean = false;
  popupContent: string = '';

  constructor(authService: AuthService, companyService: CompanyService, locationService: LocationService, vehicleService: VehicleService,
    public clientAuditReportService: ClientAuditReportService, customerTypeService: CustomerTypeService, public router: Router,
    private columnService: ColumnService) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

    customerTypeService.getAll().then((data) => {
      this.customerTypes = data;
    });

    companyService.getAll(this.filter.customer_Type_Id).then((data) => {
      this.companyList = data;
      this.companies = this.companyList;

      if (this.role.isStandard || this.role.isMasterStandard || this.role.isAdmin) {
        this.filter.company_Id = this.client.companyId;
      }

      locationService.getAll(this.filter.company_Id).then((data) => {
        this.locationList = data;
        this.locations = this.locationList;

        vehicleService.getAll(this.filter.location_Id).then((data) => {
          this.vehicleList = data;
          this.vehicles = this.vehicleList;
        });

      });

      this.loadTable(this.page);
    });

    this.companyService = companyService;
    this.locationService = locationService;
    this.vehicleService = vehicleService;
  }

  ngOnInit() {
    this.getcolumns();
    this.loadTable(this.page);
    this.init = true;
  }

  loadClientAuditCylsPage(row: any) {
    this.router.navigate(['reports/client_audit_report/cyls'], {
      queryParams: {
        client_Audit_Id: row.client_Audit_ID,
        client: true
      }
    });
  }

  // ###################################
  // Filters
  // ###################################
  onCompanyChange(value) {
    this.filter.location_Id = 0;
    this.filter.region_Id = 0;
    if (value == 0) { value = null; }

    this.locations = this.locationList.filter(c => {
      return value == null || c.company_Id == value;
    });
  }

  onCustomerTypeChange(value) {
    this.filter.company_Id = 0;
    this.onCompanyChange(0);

    if (value == 0) { value = null; }

    this.companies = this.companyList.filter(c => {
      return value == null || c.customer_Type_Id == value;
    });

  }

  onLocationChange(value) {
    if (value == 0) { value = null; }

    this.vehicles = this.vehicleList.filter(v => {
      return value == null || v.location_ID == value;
    });
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {

    if (!event.column.prop) {
      return false;
    }

    const sortMapping = {
      'starttime_Display': 'starttime_Sorting',
    };

    const sortOrder = event.newValue;
    const sortBy = sortMapping[event.column.prop] || event.column.prop;

    this.page.sortOrder = sortOrder;
    this.page.sortBy = sortBy;

    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.clientAuditReportService.getResults(this.page, this.filter.customer_Type_Id, this.filter.company_Id, this.filter.location_Id,
      this.filter.vehicle_Id, this.filter.start_Date, this.filter.end_Date, this.role.isStandard, this.filter.quick_Search).then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.clientAuditReportService.getExcel(this.filter.customer_Type_Id, this.filter.company_Id, this.filter.location_Id,
      this.filter.vehicle_Id, this.filter.start_Date, this.filter.end_Date, this.role.isStandard).then((data) => {
        importedSaveAs(data, 'Audit.xlsx');
      });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "clientAuditReport").then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "clientAuditReport", this.selectedOptions).then((data) => {
    });
  }
}

